import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { INDUSTRIES } from '../data/content';
import './Industries.css';

// ─── Animated SVGs (unchanged) ──────────────────────────────────────────────

function AerospaceAnim({ active }) {
  return (
    <svg viewBox="0 0 120 80" width="140" height="100" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="20" cy="55" rx="14" ry="8" fill="#e0eeff" opacity={active ? 1 : 0.4} />
      <ellipse cx="30" cy="50" rx="12" ry="7" fill="#e0eeff" opacity={active ? 1 : 0.4} />
      <ellipse cx="95" cy="60" rx="12" ry="7" fill="#e0eeff" opacity={active ? 1 : 0.4} />
      <ellipse cx="105" cy="56" rx="10" ry="6" fill="#e0eeff" opacity={active ? 1 : 0.4} />
      <g style={{
        transform: active ? 'translateX(18px) translateY(-10px) rotate(-8deg)' : 'translateX(0px) translateY(0px) rotate(0deg)',
        transition: 'transform 0.8s cubic-bezier(0.34,1.56,0.64,1)',
        transformOrigin: '60px 40px',
      }}>
        <ellipse cx="60" cy="42" rx="28" ry="9" fill="#1a3c5e" />
        <polygon points="48,42 38,58 72,47" fill="#2563a8" />
        <polygon points="70,42 80,30 48,38" fill="#2563a8" />
        <polygon points="32,42 24,34 36,40" fill="#4a90d9" />
        <circle cx="62" cy="40" r="4" fill="#a8d4ff" opacity="0.8" />
        {active && <>
          <line x1="32" y1="42" x2="10" y2="44" stroke="#4a90d9" strokeWidth="2" strokeDasharray="4 3" opacity="0.6" style={{animation:'trail 0.4s linear infinite'}} />
          <line x1="32" y1="44" x2="6" y2="48" stroke="#4a90d9" strokeWidth="1.5" strokeDasharray="3 4" opacity="0.4" style={{animation:'trail 0.4s linear infinite 0.1s'}} />
        </>}
      </g>
      <style>{`@keyframes trail { from{stroke-dashoffset:0} to{stroke-dashoffset:-14} }`}</style>
    </svg>
  );
}

function AutomotiveAnim({ active }) {
  return (
    <svg viewBox="0 0 120 80" width="140" height="100" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="62" width="120" height="18" fill="#dde6f0" rx="3" />
      <line x1="0" y1="71" x2="120" y2="71" stroke="#fff" strokeWidth="2" strokeDasharray="12 8"
        style={active ? {animation:'road 0.3s linear infinite'} : {}} />
      <g style={{
        transform: active ? 'translateX(12px)' : 'translateX(0px)',
        transition: 'transform 0.7s cubic-bezier(0.34,1.56,0.64,1)',
      }}>
        <rect x="28" y="38" width="52" height="24" rx="5" fill="#1a3c5e" />
        <rect x="34" y="28" width="38" height="16" rx="5" fill="#2563a8" />
        <rect x="37" y="31" width="14" height="10" rx="2" fill="#a8d4ff" opacity="0.8" />
        <rect x="55" y="31" width="14" height="10" rx="2" fill="#a8d4ff" opacity="0.8" />
        <circle cx="44" cy="63" r="9" fill="#0f2540" />
        <circle cx="44" cy="63" r="5" fill="#4a90d9"
          style={active ? {animation:'spin 0.4s linear infinite', transformOrigin:'44px 63px'} : {}} />
        <circle cx="76" cy="63" r="9" fill="#0f2540" />
        <circle cx="76" cy="63" r="5" fill="#4a90d9"
          style={active ? {animation:'spin 0.4s linear infinite', transformOrigin:'76px 63px'} : {}} />
        {active && <ellipse cx="82" cy="47" rx="5" ry="3" fill="#fff9a0" opacity="0.8" style={{filter:'blur(1px)'}} />}
        {active && <>
          <line x1="26" y1="40" x2="8" y2="40" stroke="#4a90d9" strokeWidth="2" opacity="0.5" style={{animation:'speedline 0.3s linear infinite'}} />
          <line x1="26" y1="46" x2="4" y2="46" stroke="#4a90d9" strokeWidth="1.5" opacity="0.4" style={{animation:'speedline 0.3s linear infinite 0.05s'}} />
          <line x1="26" y1="52" x2="10" y2="52" stroke="#4a90d9" strokeWidth="1" opacity="0.3" style={{animation:'speedline 0.3s linear infinite 0.1s'}} />
        </>}
      </g>
      <style>{`
        @keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        @keyframes road { from{stroke-dashoffset:0} to{stroke-dashoffset:-20} }
        @keyframes speedline { from{stroke-dashoffset:0} to{stroke-dashoffset:-20} }
      `}</style>
    </svg>
  );
}

function MedicalAnim({ active }) {
  return (
    <svg viewBox="0 0 120 80" width="140" height="100" xmlns="http://www.w3.org/2000/svg">
      <g style={{
        transform: active ? 'scale(1.15)' : 'scale(1)',
        transition: 'transform 0.3s ease',
        transformOrigin: '60px 38px',
        animation: active ? 'heartbeat 0.7s ease infinite' : 'none',
      }}>
        <path d="M60 55 C60 55 30 38 30 22 C30 14 37 8 45 10 C51 11 57 16 60 21 C63 16 69 11 75 10 C83 8 90 14 90 22 C90 38 60 55 60 55Z"
          fill="#e84b7a" opacity={active ? 1 : 0.6} />
        <rect x="55" y="22" width="10" height="22" rx="2" fill="white" opacity="0.9" />
        <rect x="49" y="28" width="22" height="10" rx="2" fill="white" opacity="0.9" />
      </g>
      <polyline
        points={active ? "0,65 20,65 28,65 32,48 36,72 40,55 44,65 120,65" : "0,65 120,65"}
        fill="none" stroke="#e84b7a" strokeWidth="2.5"
        style={active ? {animation:'ecg 1s ease infinite', strokeDasharray:200, strokeDashoffset:200} : {opacity:0.3}}
      />
      <style>{`
        @keyframes heartbeat { 0%,100%{transform:scale(1.0)} 14%{transform:scale(1.2)} 28%{transform:scale(1.0)} 42%{transform:scale(1.15)} 70%{transform:scale(1.0)} }
        @keyframes ecg { from{stroke-dashoffset:200} to{stroke-dashoffset:0} }
      `}</style>
    </svg>
  );
}

function DefenseAnim({ active }) {
  return (
    <svg viewBox="0 0 120 80" width="140" height="100" xmlns="http://www.w3.org/2000/svg">
      <g style={{ transform: active ? 'translateY(-4px)' : 'translateY(0)', transition: 'transform 0.5s ease' }}>
        <path d="M60 8 L88 20 L88 46 C88 60 60 72 60 72 C60 72 32 60 32 46 L32 20 Z" fill="#1a3c5e" stroke="#4a90d9" strokeWidth="2" />
        <path d="M60 14 L82 24 L82 44 C82 56 60 66 60 66 C60 66 38 56 38 44 L38 24 Z" fill="#2563a8" opacity="0.5" />
        <polygon points="60,24 62.5,31 70,31 64,35.5 66.5,43 60,38.5 53.5,43 56,35.5 50,31 57.5,31" fill="#a8d4ff" opacity={active ? 1 : 0.6} />
      </g>
      {active && <>
        <circle cx="60" cy="40" r="20" fill="none" stroke="#4a90d9" strokeWidth="1.5" opacity="0.6" style={{animation:'radar 1.2s ease-out infinite'}} />
        <circle cx="60" cy="40" r="32" fill="none" stroke="#4a90d9" strokeWidth="1" opacity="0.3" style={{animation:'radar 1.2s ease-out infinite 0.4s'}} />
        <circle cx="60" cy="40" r="44" fill="none" stroke="#4a90d9" strokeWidth="0.5" opacity="0.15" style={{animation:'radar 1.2s ease-out infinite 0.8s'}} />
      </>}
      <style>{`@keyframes radar { 0%{opacity:0.8;transform:scale(0.5)} 100%{opacity:0;transform:scale(1.2)} }`}</style>
    </svg>
  );
}

function SemiconductorAnim({ active }) {
  return (
    <svg viewBox="0 0 120 80" width="140" height="100" xmlns="http://www.w3.org/2000/svg">
      <rect x="35" y="20" width="50" height="40" rx="4" fill="#1a3c5e" stroke="#4a90d9" strokeWidth="1.5" />
      <rect x="40" y="25" width="40" height="30" rx="3" fill="#2563a8" opacity="0.5" />
      <text x="60" y="43" textAnchor="middle" fill="#a8d4ff" fontSize="9" fontFamily="monospace" fontWeight="bold">DWB</text>
      {[28,34,40,46,52].map((y, i) => (
        <g key={i}>
          <rect x="22" y={y} width="13" height="4" rx="1" fill="#4a90d9" style={active ? {animation:`pin 0.6s ease ${i*0.1}s infinite alternate`} : {}} />
          <rect x="85" y={y} width="13" height="4" rx="1" fill="#4a90d9" style={active ? {animation:`pin 0.6s ease ${i*0.1+0.3}s infinite alternate`} : {}} />
        </g>
      ))}
      {active && <>
        <line x1="22" y1="30" x2="8" y2="30" stroke="#0ea5e9" strokeWidth="1.5" opacity="0.7" style={{animation:'signal 0.5s linear infinite'}} />
        <line x1="22" y1="42" x2="5" y2="42" stroke="#0ea5e9" strokeWidth="1.5" opacity="0.7" style={{animation:'signal 0.5s linear infinite 0.2s'}} />
        <line x1="22" y1="54" x2="8" y2="54" stroke="#0ea5e9" strokeWidth="1.5" opacity="0.7" style={{animation:'signal 0.5s linear infinite 0.4s'}} />
        <line x1="98" y1="30" x2="112" y2="30" stroke="#0ea5e9" strokeWidth="1.5" opacity="0.7" style={{animation:'signal2 0.5s linear infinite'}} />
        <line x1="98" y1="42" x2="115" y2="42" stroke="#0ea5e9" strokeWidth="1.5" opacity="0.7" style={{animation:'signal2 0.5s linear infinite 0.2s'}} />
        <line x1="98" y1="54" x2="112" y2="54" stroke="#0ea5e9" strokeWidth="1.5" opacity="0.7" style={{animation:'signal2 0.5s linear infinite 0.4s'}} />
      </>}
      {active && <rect x="35" y="20" width="50" height="40" rx="4" fill="none" stroke="#4a90d9" strokeWidth="3" opacity="0.4" style={{animation:'glow 1s ease infinite alternate', filter:'blur(2px)'}} />}
      <style>{`
        @keyframes pin { from{fill:#4a90d9} to{fill:#0ea5e9} }
        @keyframes signal { from{stroke-dashoffset:0;opacity:0.7} to{stroke-dashoffset:-14;opacity:0.2} }
        @keyframes signal2 { from{stroke-dashoffset:0;opacity:0.7} to{stroke-dashoffset:14;opacity:0.2} }
        @keyframes glow { from{opacity:0.2} to{opacity:0.6} }
      `}</style>
    </svg>
  );
}

const ANIM_COMPONENTS = [AerospaceAnim, AutomotiveAnim, MedicalAnim, DefenseAnim, SemiconductorAnim];

// ─── Industry data with hero images and detail content ───────────────────────

const INDUSTRY_DETAILS = [
  {
    slug: 'aerospace',
    heroImage: 'https://images.unsplash.com/photo-1541185933-ef5d8ed016c2?w=1600&q=80',
    heroColor: 'from-[#0f2540] to-[#1a3c5e]',
    stats: [{ label: 'Years Experience', value: '32+' }, { label: 'Projects Delivered', value: '500+' }, { label: 'Certifications', value: 'AS9100D' }],
    capabilities: ['Avionics PCB Design', 'MIL-SPEC Compliance', 'High-Reliability Assemblies', 'Satellite Systems', 'Flight Control Electronics', 'EMI/EMC Testing'],
    detail: 'DWB Tech delivers mission-critical PCB and ASIC solutions for the aerospace sector, meeting the most stringent reliability and quality standards. Our designs power avionics, satellite communications, navigation systems, and UAV platforms worldwide.',
  },
  {
    slug: 'automotive',
    heroImage: 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1600&q=80',
    heroColor: 'from-[#0f2540] to-[#1e3a5f]',
    stats: [{ label: 'OEM Partners', value: '30+' }, { label: 'ECU Designs', value: '200+' }, { label: 'Standard', value: 'IATF 16949' }],
    capabilities: ['ADAS PCB Design', 'ECU Development', 'EV Power Electronics', 'CAN/LIN/FlexRay', 'Functional Safety (ISO 26262)', 'Thermal Management'],
    detail: 'From ADAS to full EV platforms, DWB Tech engineers robust automotive-grade electronics that meet AEC-Q100 and ISO 26262 functional safety requirements. Our expertise spans powertrain, body electronics, infotainment, and next-gen autonomous driving modules.',
  },
  {
    slug: 'medical',
    heroImage: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=1600&q=80',
    heroColor: 'from-[#1a0f2e] to-[#2a1854]',
    stats: [{ label: 'FDA Compliant', value: '100%' }, { label: 'Devices Shipped', value: '1M+' }, { label: 'Standard', value: 'ISO 13485' }],
    capabilities: ['Medical Device PCB', 'IEC 60601 Compliance', 'Wearable Electronics', 'Imaging Systems', 'Patient Monitoring', 'Implantable Devices'],
    detail: 'Patient safety is paramount. DWB Tech designs ultra-reliable medical electronics compliant with IEC 60601 and ISO 13485. Our portfolio spans portable diagnostics, surgical robotics, imaging systems, and life-critical monitoring equipment.',
  },
  {
    slug: 'defense',
    heroImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=80',
    heroColor: 'from-[#0a1628] to-[#1a3c5e]',
    stats: [{ label: 'Security Cleared', value: 'Yes' }, { label: 'MIL-STD', value: 'Compliant' }, { label: 'Uptime', value: '99.99%' }],
    capabilities: ['Ruggedized Electronics', 'MIL-STD-810 Testing', 'Radar & Sonar Systems', 'Secure Communications', 'Electronic Warfare', 'TEMPEST Compliance'],
    detail: 'Defense applications demand zero compromise. DWB Tech provides ruggedized, MIL-STD-810 compliant electronics for ground vehicles, naval systems, airborne platforms, and secure communications. We engineer resilience into every layer of the design.',
  },
  {
    slug: 'semiconductor',
    heroImage: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1600&q=80',
    heroColor: 'from-[#0d1b2e] to-[#1a3c5e]',
    stats: [{ label: 'Node Support', value: '7nm+' }, { label: 'Tape-outs', value: '100+' }, { label: 'Design Environments', value: 'Advanced ASIC & Verification Flows' }],
    capabilities: ['RTL Design & Synthesis', 'Physical Design', 'DRC/LVS Signoff', 'ATE Board Design', 'Library Development', 'Formal Verification'],
    detail: 'DWB Tech accelerates semiconductor development from RTL to GDSII. Our ASIC design flow, verification services, and custom library development support leading foundries from 7nm to mature nodes — delivering first-pass silicon success.',
  },
];

// ─── Particle background ─────────────────────────────────────────────────────

function ParticleCanvas() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let raf;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const particles = Array.from({ length: 60 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 1.5 + 0.3,
      vx: (Math.random() - 0.5) * 0.3,
      vy: (Math.random() - 0.5) * 0.3,
      opacity: Math.random() * 0.5 + 0.1,
    }));
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(74,144,217,${p.opacity})`;
        ctx.fill();
      });
      // Draw connecting lines
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 100) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(74,144,217,${0.12 * (1 - dist / 100)})`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} className="ind-particle-canvas" />;
}

// ─── Hero Banner ─────────────────────────────────────────────────────────────

function IndustryHeroBanner({ onExplore }) {
  return (
    <div className="ind-hero-banner">
      <ParticleCanvas />
      <div className="ind-hero-grid" />  
      <div className="ind-hero-content">
        <div className="ind-hero-tag">Industries We Serve</div>
        <h1 className="ind-hero-title">
          Powering Innovation<br />
          <span className="ind-hero-accent">Across Every Sector</span>
        </h1>
        <p className="ind-hero-sub">
          From aerospace avionics to semiconductor silicon — DWB Tech delivers precision electronics engineering for the world's most demanding industries.
        </p>
        <div className="ind-hero-stats">
          {[['500+', 'Projects Delivered'], ['32+', 'Years Experience'], ['50+', 'Global Clients'], ['5', 'Key Industries']].map(([val, label]) => (
            <div key={label} className="ind-hero-stat">
              <span className="ind-hero-stat-val">{val}</span>
              <span className="ind-hero-stat-label">{label}</span>
            </div>
          ))}
        </div>
        <button className="ind-hero-cta" onClick={onExplore}>
          Explore Industries
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12l7 7 7-7" /></svg>
        </button>
      </div>
      {/* Floating industry icons */}
     
    </div>
  );
}

// ─── Industry Cards Grid ─────────────────────────────────────────────────────

function IndustryCards({ navigate }) {
  return (
    <div className="ind-cards-grid">
      {INDUSTRIES.map((ind, i) => {
        const detail = INDUSTRY_DETAILS[i];
        return (
          <div
            key={ind.name}
            className="ind-card"
            onClick={() => navigate(`/industries/${detail.slug}`)}
          >
            <div className="ind-card-bg" style={{ backgroundImage: `url(${detail.heroImage})` }} />
            <div className="ind-card-overlay" />
            <div className="ind-card-content">
             
              <h3 className="ind-card-title">{ind.name}</h3>
              <p className="ind-card-desc">{ind.desc}</p>
              <div className="ind-card-stats">
                {detail.stats.map(s => (
                  <div key={s.label} className="ind-card-stat">
                    <span className="ind-card-stat-val">{s.value}</span>
                    <span className="ind-card-stat-label">{s.label}</span>
                  </div>
                ))}
              </div>
              <div className="ind-card-cta">
                Learn More
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ─── Detail panel (existing tab layout, kept intact) ─────────────────────────

function IndustryTabSection() {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  const AnimComp = ANIM_COMPONENTS[active];
  const detail = INDUSTRY_DETAILS[active];

  return (
    <div className="ind-tab-section">
      <div className="ind-tab-header">
        <div className="section-tag">Deep Dive</div>
        <h2 className="section-heading">Select an Industry to Explore</h2>
      </div>
      <div className="ind-layout">
        {/* Tabs */}
        <div className="ind-tabs">
          {INDUSTRIES.map((ind, i) => (
            <button
              key={ind.name}
              className={`ind-tab${active === i ? ' ind-tab--active' : ''}`}
              onClick={() => setActive(i)}
            >
            
              <span className="ind-tab-name">{ind.name}</span>
              <span className="ind-tab-arrow">→</span>
            </button>
          ))}
        </div>

        {/* Panel */}
        <div className="ind-panel">
          <div className="ind-panel-anim">
            <AnimComp active={true} />
          </div>
          <h3 className="ind-panel-title">{INDUSTRIES[active].name}</h3>
          <p className="ind-panel-desc">{detail.detail}</p>
          <div className="ind-panel-capabilities">
            {detail.capabilities.map(c => (
              <span key={c} className="ind-cap-tag">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M20 6L9 17l-5-5" /></svg>
                {c}
              </span>
            ))}
          </div>
          <div className="ind-panel-tags">
            {['High Reliability', 'Quality Assured', 'On-Time Delivery'].map(t => (
              <span key={t} className="ind-tag">{t}</span>
            ))}
          </div>
          <div className="ind-panel-actions">
            <button
              className="btn-primary ind-cta"
              onClick={() => navigate(`/industries/${detail.slug}`)}
            >
              View Full Details
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginLeft: 8 }}>
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
            <a href="/contact" className="ind-cta-secondary">Discuss Your Project</a>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Main Industries Component ────────────────────────────────────────────────

export default function Industries() {
  const navigate = useNavigate();
  const cardsRef = useRef(null);

  const scrollToCards = () => {
    cardsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="industries-page">
      {/* Hero Banner */}
      <IndustryHeroBanner onExplore={scrollToCards} />

      {/* Cards Grid */}
      <section className="industries-section" ref={cardsRef}>
        <div className="industries-inner">
          <div className="section-header reveal">
            <div className="section-tag">Our Sectors</div>
            <h2 className="section-heading">
              Industries We <span className="gradient-text">Serve</span>
            </h2>
            <p className="section-sub">Click any industry card to explore our full capabilities and case studies.</p>
          </div>
          <IndustryCards navigate={navigate} />
        </div>
      </section>

      {/* Existing Tab Section (kept intact) */}
     
    </div>
  );
}

// ─── Industry Detail Page ─────────────────────────────────────────────────────

export function IndustryDetailPage() {
  const navigate = useNavigate();
  // Get slug from URL - works with react-router useParams
  const slug = window.location.pathname.split('/').pop();
  const idx = INDUSTRY_DETAILS.findIndex(d => d.slug === slug);
  const detail = INDUSTRY_DETAILS[idx] ?? INDUSTRY_DETAILS[0];
  const ind = INDUSTRIES[idx] ?? INDUSTRIES[0];
  const AnimComp = ANIM_COMPONENTS[idx] ?? ANIM_COMPONENTS[0];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  return (
    <div className="ind-detail-page">
      {/* Hero */}
      <div className="ind-detail-hero" style={{ backgroundImage: `url(${detail.heroImage})` }}>
        <div className="ind-detail-hero-overlay" />
        <div className="ind-detail-hero-content">
          <button className="ind-back-btn" onClick={() => navigate('/industries')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
            All Industries
          </button>
         
          <h1 className="ind-detail-title">{ind.name}</h1>
          <p className="ind-detail-subtitle">{detail.detail}</p>
          <div className="ind-detail-stats">
            {detail.stats.map(s => (
              <div key={s.label} className="ind-detail-stat">
                <span className="ind-detail-stat-val">{s.value}</span>
                <span className="ind-detail-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="ind-detail-body">
        <div className="ind-detail-inner">

          {/* SVG Animation */}
          <div className="ind-detail-anim-wrap">
            <AnimComp active={true} />
          </div>

          {/* Capabilities */}
          <div className="ind-detail-capabilities">
            <h2 className="ind-detail-section-title">Our Capabilities</h2>
            <div className="ind-detail-caps-grid">
              {detail.capabilities.map(cap => (
                <div key={cap} className="ind-detail-cap-card">
                  <div className="ind-detail-cap-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5" /></svg>
                  </div>
                  <span>{cap}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Why DWB */}
          <div className="ind-detail-why">
            <h2 className="ind-detail-section-title">Why DWB Tech?</h2>
            <div className="ind-detail-why-grid">
              {[
                { icon: '🏆', title: 'Industry Certified', desc: 'Compliant with all major industry standards and certifications.' },
                { icon: '⚡', title: 'Fast Turnaround', desc: 'Rapid prototyping and production with on-time delivery guarantee.' },
                { icon: '🔬', title: 'Engineering Depth', desc: 'Deep domain expertise across hardware, ASIC, and software layers.' },
                { icon: '🌍', title: 'Global Reach', desc: 'Serving clients across North America, Europe, and Asia-Pacific.' },
              ].map(w => (
                <div key={w.title} className="ind-detail-why-card">
                  <div className="ind-detail-why-icon">{w.icon}</div>
                  <h4>{w.title}</h4>
                  <p>{w.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="ind-detail-cta-section">
            <h2>Ready to Start Your {ind.name} Project?</h2>
            <p>Talk to our engineers and get a free consultation tailored to your sector.</p>
            <div className="ind-detail-cta-btns">
              <a href="/contact" className="btn-primary">Get Free Consultation</a>
              <a href="/services" className="ind-cta-secondary">View All Services</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}